import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-10" }
const _hoisted_2 = { class: "grid grid-cols-4 gap-x-8 my-4" }
const _hoisted_3 = { class: "col-span-4 grid grid-cols-4 gap-x-8 gap-y-2 pt-4" }
const _hoisted_4 = { class: "col-span-4 grid grid-cols-4 gap-x-8 gap-y-2 pt-4" }
const _hoisted_5 = { class: "col-span-4 grid grid-cols-4 gap-x-8 gap-y-2 pt-4" }
const _hoisted_6 = { class: "flex justify-end gap-3 pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NeComputedUserPreference, (el, i) => {
        return (_openBlock(), _createBlock(_component_Checkbox, {
          key: i,
          for_id: el.prop,
          checked: el.visible,
          onChange: ($event: any) => (_ctx.onToggle(el.prop)),
          checkClass: "w-2 h-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(el.name), 1)
          ]),
          _: 2
        }, 1032, ["for_id", "checked", "onChange"]))
      }), 128)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-span-4 font-bold py-2" }, "Acquisto", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AcComputedUserPreference, (el, i) => {
          return (_openBlock(), _createBlock(_component_Checkbox, {
            key: i,
            for_id: el.prop,
            checked: el.visible,
            onChange: ($event: any) => (_ctx.onToggle(el.prop)),
            checkClass: "w-2 h-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(el.name), 1)
            ]),
            _: 2
          }, 1032, ["for_id", "checked", "onChange"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-span-4 font-bold py-2" }, "Vendita", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.VeComputedUserPreference, (el, i) => {
          return (_openBlock(), _createBlock(_component_Checkbox, {
            key: i,
            for_id: el.prop,
            checked: el.visible,
            onChange: ($event: any) => (_ctx.onToggle(el.prop)),
            checkClass: "w-2 h-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(el.name), 1)
            ]),
            _: 2
          }, 1032, ["for_id", "checked", "onChange"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-span-4 font-bold py-2" }, "Totali", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ReComputedUserPreference, (el, i) => {
          return (_openBlock(), _createBlock(_component_Checkbox, {
            key: i,
            for_id: el.prop,
            checked: el.visible,
            onChange: ($event: any) => (_ctx.onToggle(el.prop)),
            checkClass: "w-2 h-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(el.name), 1)
            ]),
            _: 2
          }, 1032, ["for_id", "checked", "onChange"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_NextButton, {
        variant: "outline-secondary",
        onClick: _ctx.chiudi,
        class: "w-44 py-2 px-4"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Chiudi ")
        ])),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_NextButton, {
        variant: "primary",
        onClick: _ctx.salva,
        class: "w-44 py-2 px-4"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode(" Salva ")
        ])),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}